import { v4 as uuidv4 } from "uuid";

/**
 * Creates a free cart item object for promotional purposes.
 *
 * @param {any} item - The item object containing details about the product.
 * @param {number} count - The quantity of the item to be added to the cart.
 * @param {boolean} isModifierIncluded - Indicates if modifiers are included in the subtotal calculation.
 * @param {number} appliedPromotionId - The ID of the applied promotion.
 * @param {number} appliedPromotionPriority - The priority of the applied promotion.
 *
 * @returns {object} - The constructed cart item object with properties such as id, name, pricing, and other details.
 */
export const createFreeCartItem = (
  item: any,
  count: number,
  isModifierIncluded: boolean,
  appliedPromotionId: number,
  appliedPromotionPriority: number
) => {
  return {
    id: item.id,
    type: item.type,
    name: item.name,
    unit_price: item.unit_price,
    final_price: item.final_price,
    short_description: item.short_description,
    image_url: item.image_url,
    groups: item.groups,
    taxes: item.taxes,
    sequence_no: item.sequence_no,
    is_popular: item.is_popular,
    tags: item.tags,
    translations: item.translations,
    count: count,
    promotionIncludesModifier: !isModifierIncluded,
    sub_total: 0,
    cart_id: uuidv4(),
    is_free_item: true,
    applied_promotion_id: appliedPromotionId,
    applied_promotion_priority: appliedPromotionPriority,
  };
};
